<h1 mat-dialog-title>Create Team</h1>
<div mat-dialog-content>
  <mat-form-field>
    <mat-label>Team Name</mat-label>
    <input matInput [(ngModel)]="data.teamName" (keyup.enter)="saveTeam()">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="close(false)">Cancel</button>
  <button mat-button [mat-dialog-close]="data.teamName" (click)="saveTeam()">Save</button>
</div>